import { Skeleton } from 'antd';

import { SkeletonNodeListContainer } from './SkeletonNodeList.styles';

const SkeletonNodeList = ({
  isLoading,
  count = 1,
  children,
  itemWidth = 280,
  itemHeight = 100,
  shouldCenterHorizontally = false,
}: {
  isLoading: boolean;
  count?: number;
  children?: React.ReactNode;
  itemWidth?: number;
  itemHeight?: number;
  shouldCenterHorizontally?: boolean;
}) => {
  return isLoading ? (
    <SkeletonNodeListContainer $shouldCenterHorizontally={shouldCenterHorizontally}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton.Node active key={index} style={{ width: itemWidth, height: itemHeight }} />
      ))}
    </SkeletonNodeListContainer>
  ) : (
    <>{children}</>
  );
};

export default SkeletonNodeList;
